"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePromotions = void 0;
var next_intl_1 = require("next-intl");
var react_1 = require("react");
var currencies_1 = require("../currencies");
var geo_1 = require("../geo");
var keys_1 = require("../keys");
var useCache_1 = require("../useCache");
var useQuery_1 = require("../useQuery");
var CURRENT_CURRENCY = 'promotion_current_currency';
var CURRENT_LANG = 'promotion_current_lang';
var CURRENT_COUNTRY = 'promotion_current_country';
var usePromotions = function () {
    var _a;
    var currentCurrency = (0, currencies_1.useCurrentCurrency)();
    var _b = (0, useCache_1.useCache)(), getDataFromCache = _b.getDataFromCache, setDataToCache = _b.setDataToCache;
    var lang = (0, next_intl_1.useLocale)();
    var geoData = (0, geo_1.useGeo)().data;
    var country = (_a = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _a === void 0 ? void 0 : _a.countryCode;
    var _c = (0, useQuery_1.useQuery)({
        canRender: !!country && lang && currentCurrency,
        path: keys_1.PROMOTIONS,
        payload: {
            input: {
                currency: currentCurrency,
                lang: lang,
                country: country,
            },
        },
        onErrorRetry: function () { return false; },
    }), data = _c.data, error = _c.error, isLoading = _c.isLoading, mutate = _c.mutate;
    (0, react_1.useEffect)(function () {
        var prevCurrency = getDataFromCache(CURRENT_CURRENCY);
        var prevLang = getDataFromCache(CURRENT_LANG);
        var prevCountry = getDataFromCache(CURRENT_COUNTRY);
        if ((prevCurrency && prevCurrency !== currentCurrency) ||
            (prevLang && prevLang !== lang) ||
            (prevCountry && prevCountry !== country)) {
            mutate();
        }
        if (!prevCurrency ||
            prevCurrency !== currentCurrency ||
            !prevLang ||
            prevLang !== lang ||
            prevCountry !== country) {
            setDataToCache(CURRENT_CURRENCY, currentCurrency);
            setDataToCache(CURRENT_LANG, lang);
            setDataToCache(CURRENT_COUNTRY, country);
        }
    }, [
        getDataFromCache,
        setDataToCache,
        currentCurrency,
        mutate,
        lang,
        country,
    ]);
    return (0, react_1.useMemo)(function () { return ({
        data: (data === null || data === void 0 ? void 0 : data.data) || [],
        isLoading: isLoading,
        error: error,
    }); }, [data, isLoading, error, country]);
};
exports.usePromotions = usePromotions;
